import { memo, useId } from "react";
import { PartialIndicator } from "../../primitives";
import { Icon, type IconColor } from "../../primitives/Icon";
import { PortaledTooltip } from "../../ui/Tooltip";

export type DetailStatusCellProps = {
	label: string;
	active?: boolean;
	activeColor?: IconColor;
	tooltip?: string;
	partial?: boolean;
};

export const DetailStatusCell = memo(
	({ label, active, activeColor = "confirm", tooltip, partial = false }: DetailStatusCellProps) => {
		const tooltipId = useId();

		return (
			<div
				className="flex items-center gap-[4px]"
				data-tooltip-id={tooltip ? tooltipId : undefined}
			>
				<span className="text-[12px] font-medium text-tertiary italic">{label}</span>
				{active === undefined ? (
					<span className="text-[12px] text-tertiary">N/A</span>
				) : (
					<Icon
						type={active ? "check" : "x-mark"}
						color={active ? activeColor : "tertiary"}
						size="mini"
					/>
				)}
				{partial && <PartialIndicator active testId="detail-status-partial" />}
				{tooltip && <PortaledTooltip id={tooltipId} content={tooltip} />}
			</div>
		);
	},
);
